import { useEffect, useState } from "react";
import API from "../api";

export default function AnalyticsAndReports() {

  const [stats, setStats] = useState({
    users: 0,
    bookings: 0,
    revenue: 0,
    conversion: 0
  });

  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ===============================
     FETCH DASHBOARD DATA
  =============================== */
  const fetchAnalytics = async () => {
    try {
      const token =
        localStorage.getItem("token") ||
        sessionStorage.getItem("token");

      // 🔥 MAIN DASHBOARD STATS
      const res = await fetch(`${API}/dashboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = await res.json();

      setStats({
        users: data.data?.totalUsers || 0,
        bookings: data.data?.totalBookings || 0,
        revenue: data.data?.totalRevenue || 0,
        conversion: data.data?.conversionRate || 0
      });

      // 🔥 RECENT ACTIVITY (notifications table)
      const notifRes = await fetch(`${API}/notifications`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const notifData = await notifRes.json();
      setActivities(notifData.data || []);

    } catch (err) {
      console.error("❌ Analytics error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  /* ===============================
     FORMATTERS
  =============================== */
  const formatCurrency = (val) => {
    return "₱" + Number(val).toLocaleString();
  };

  return (
    <div className="space-y-6">

      {/* Header */}
      <div>
        <h2 className="text-3xl font-bold mb-2">Analytics Reports</h2>
        <p className="text-gray-500">
          Overview of system performance and user activity
        </p>
      </div>

      {/* KPI CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Total Users</h4>
          <p className="text-2xl font-bold mt-2">
            {loading ? "..." : stats.users}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Bookings</h4>
          <p className="text-2xl font-bold mt-2">
            {loading ? "..." : stats.bookings}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Revenue</h4>
          <p className="text-2xl font-bold mt-2">
            {loading ? "..." : formatCurrency(stats.revenue)}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Conversion Rate</h4>
          <p className="text-2xl font-bold mt-2">
            {loading ? "..." : stats.conversion + "%"}
          </p>
        </div>

      </div>

      {/* CHARTS SECTION (READY FOR REAL DATA) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h3 className="text-lg font-semibold mb-4">
            Traffic Overview
          </h3>

          <div className="h-48 flex items-center justify-center text-gray-400">
            {/* 🔥 Ready for chart library */}
            Coming Soon (Real Chart Data Ready)
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h3 className="text-lg font-semibold mb-4">
            Revenue Growth
          </h3>

          <div className="h-48 flex items-center justify-center text-gray-400">
            Coming Soon (Real Chart Data Ready)
          </div>
        </div>

      </div>

      {/* RECENT ACTIVITY */}
      <div className="bg-white p-6 rounded-xl shadow-sm border">
        <h3 className="text-lg font-semibold mb-4">
          Recent Activity
        </h3>

        {loading ? (
          <p className="text-gray-400">Loading...</p>
        ) : activities.length === 0 ? (
          <p className="text-gray-400">No recent activity</p>
        ) : (
          <ul className="space-y-3 text-sm text-gray-600">
            {activities.slice(0, 5).map((a, i) => (
              <li key={i}>
                ✔ {a.title || a.description}
              </li>
            ))}
          </ul>
        )}
      </div>

    </div>
  );
}